import React, { FC } from "react";
import { useLocation, useParams } from "react-router-dom";

import { Spinner } from "@at/design-system-elements";
import { useQuery } from "@at/sauron-platform-graphql";

import {
  LeasingTechnicalSpecificationQuery,
  LeasingTechnicalSpecificationQueryVariables,
} from "./query/__generated__/leasing-technical-specification.query";
import { leasingTechnicalSpecificationQuery } from "./query/leasing-technical-specification.query";
import { getStandardEquipmentData } from "./utils/get-standard-equipment-data/get-standard-equipment-data";
import { getTechSpecData } from "./utils/get-tech-spec-data/get-tech-spec-data";
import { TechnicalSpecificationList } from "../../components/technical-specification-list/technical-specification-list";
import { ProductPageVariables } from "../../pages/leasing/leasing-product-page-content.types";
import { buildStateFromRequest } from "../../utils/leasing/state/state-utils";

export const LeasingTechnicalSpecificationModal: FC = () => {
  const location = useLocation();
  const { advertId } = useParams<ProductPageVariables>();
  const { leaseOption } = buildStateFromRequest(location.search, "PRODUCT");
  const shouldSkipQuery = !advertId && !leaseOption;

  const { data, loading, error } = useQuery<
    LeasingTechnicalSpecificationQuery,
    LeasingTechnicalSpecificationQueryVariables
  >(leasingTechnicalSpecificationQuery, {
    errorPolicy: "all",
    variables: {
      advertId,
      leaseOption,
    },
    skip: shouldSkipQuery,
  });

  const techSpecData = getTechSpecData(data?.search.advert);
  const standardEquipmentData = getStandardEquipmentData(data?.search.advert);

  if (loading) return <Spinner />;

  if (error)
    return <p>There was an error loading this data, please try again later.</p>;

  return (
    <TechnicalSpecificationList
      techSpecData={techSpecData}
      standardEquipmentData={standardEquipmentData}
    />
  );
};
